import React from 'react';
import { connect } from 'react-redux';
import { Input, Checkbox, Button, Table, Radio, Form } from 'semantic-ui-react';
import moment from 'moment';
import ReactPaginate from 'react-paginate';
import debounce from '../../../utils/debounce';
import {
  LinkBlock,
  StyledLink,
  NameBlock,
  ButtonBlock,
  DishTitleLabel,
} from '../CreateTrainingList/TrainingList';
import Navbar from '../Navigation/Navbar';
import {
  Label,
  H1,
  InputSearchBlock,
  TagsGroup,
  TableBlock,
  Block,
  CourseButton,
  UserButton,
  H2,
  CentredBlock,
  FooterBlock,
} from './ClienListStyles';
import * as action from '../../../actions/newYouslim';
import ChangeComplexStartDateModal from './ChangeComplexStartDateModal';
import { DEFAULT_TYPE_PAYMENT } from '../youslim2.0_Constants';

const optionsCourseType = [
  {
    id: 'Subscription',
    value: 'Subscription',
    label: 'Подписка',
  },
  {
    id: 'Manual',
    value: 'Manual',
    label: 'Ручной',
  },
  {
    id: 'allCourseType',
    value: 'allCourseType',
    label: 'Все',
  },
];

const optionsPaymentStatus = [
  {
    id: 'coursePaid',
    value: 'coursePaid',
    label: 'Курс оплачен',
  },
  {
    id: 'courseNotPaid',
    value: 'courseNotPaid',
    label: 'Курс не оплачен',
  },
  {
    id: 'allCoursePaid',
    value: 'allCoursePaid',
    label: 'Все',
  },
];

const optionsIsCourseActive = [
  {
    id: 'activeCourse',
    value: 'activeCourse',
    label: 'Курс активен',
  },
  {
    id: 'notActiveCourse',
    value: 'notActiveCourse',
    label: 'Курс не активен',
  },
  {
    id: 'allCourseActive',
    value: 'allCourseActive',
    label: 'Все',
  },
];

const ClientList = ({ usersList, isUsersListLoading, getUsersList }) => {
  const [isChangeComplexStartDate, setIsChangeComplexStartDate] = React.useState(false);
  const [selectedCourseType, setCourseType] = React.useState('allCourseType');
  const [selectedPaymentStatus, setPaymentStatus] = React.useState('allCoursePaid');
  const [selectedIsCourseActive, setIsCourseActive] = React.useState('allCourseActive');
  const [complexDates, setComplexDates] = React.useState(undefined);
  const [startComplexDate, setStartComplexDate] = React.useState('');

  const [endComplexDate, setEndComplexDate] = React.useState('');
  const [currentPage, setCurrentPage] = React.useState(
    (usersList && usersList.meta && usersList.meta.current_page) || 1,
  );
  const [searchValue, setSearchValue] = React.useState('');
  const [searchInputValue, setSearchInputValue] = React.useState('');

  React.useEffect(() => {
    getUsersList({ page: 1 });
  }, []);

  React.useEffect(() => {
    const searchedData = {};
    if (currentPage) {
      searchedData.page = currentPage;
    }
    if (searchValue) {
      searchedData.name = searchValue;
    }
    if (selectedIsCourseActive === 'notActiveCourse') {
      searchedData.active_course = false;
    } else if (selectedIsCourseActive === 'activeCourse') {
      searchedData.active_course = true;
    }
    if (selectedPaymentStatus === 'courseNotPaid') {
      searchedData.course_is_paid = false;
    } else if (selectedPaymentStatus === 'coursePaid') {
      searchedData.course_is_paid = true;
    }
    if (selectedCourseType === 'Manual') {
      searchedData.type_payment = 1;
    } else if (selectedCourseType === 'Subscription') {
      searchedData.type_payment = 2;
    }

    if (complexDates) {
      const startDate = moment(complexDates[0]).format('YYYY-MM-DD');
      const endDate = moment(complexDates[1]).format('YYYY-MM-DD');

      setStartComplexDate(startDate);
      setEndComplexDate(endDate);
      searchedData.user_create_from_date = startDate;
      searchedData.user_create_to_date = endDate;
    }

    getUsersList(searchedData);
  }, [
    complexDates,
    selectedIsCourseActive,
    selectedPaymentStatus,
    selectedCourseType,
    searchValue,
    currentPage,
  ]);

  const onHandleDateChange = () => {
    setIsChangeComplexStartDate(true);
  };

  const clearFilters = () => {
    setCurrentPage(1);
    setComplexDates(undefined);
    setStartComplexDate('');
    setEndComplexDate('');
    setSearchValue('');
    setCourseType('allCourseType');
    setPaymentStatus('allCoursePaid');
    setIsCourseActive('allCourseActive');
    setSearchInputValue('');
  };

  const onHandleClearDate = () => {
    setComplexDates(undefined);
    setStartComplexDate('');
    setEndComplexDate('');
  };

  const onChangeComplexStartDate = (data) => {
    setCurrentPage(1);
    setIsChangeComplexStartDate(false);
  };

  const onSearch = React.useCallback(
    debounce((value) => {
      setCurrentPage(1);
      setSearchValue(value);
    }, 700),
    [],
  );
  const onClientSearch = (value) => {
    setSearchInputValue(value);
    onSearch(value);
  };

  const handlePageClick = React.useCallback(
    (page) => {
      setCurrentPage(page.selected + 1);
    },
    [getUsersList, searchValue],
  );

  const onClickCourseType = React.useCallback(
    (type) => {
      setCurrentPage(1);
      setCourseType(type);
    },
    [setCourseType],
  );

  const onClickPaymentStatus = React.useCallback(
    (status) => {
      setCurrentPage(1);
      setPaymentStatus(status);
    },
    [setPaymentStatus],
  );
  const onClickIsCourseActive = React.useCallback(
    (isActive) => {
      setCurrentPage(1);
      setIsCourseActive(isActive);
    },
    [setIsCourseActive],
  );

  return (
    <React.Fragment>
      <Navbar> </Navbar>

      <H1> Список клиентов </H1>
      <InputSearchBlock>
        <Label>Поиск по имени/id/e-mail</Label>
        <Input
          type="search"
          placeholder="Введите имя, e-mail либо id"
          style={{ width: '100%', margin: '15px' }}
          value={searchInputValue}
          className="template-name-input"
          onChange={(e) => onClientSearch(e.target.value)}
        />
      </InputSearchBlock>
      <div>
        <H2> Фильтровать </H2>
        <CentredBlock>
          <Button onClick={clearFilters}>Cбросить фильтры</Button>
        </CentredBlock>
      </div>

      <TagsGroup>
        <Block>
          <Label> По дате </Label>
          {startComplexDate && endComplexDate ? (
            <div>
              <Button color="blue" onClick={onHandleClearDate}>
                Сбросить дату
              </Button>
              <div>
                {startComplexDate} - {endComplexDate}
              </div>
            </div>
          ) : (
            <Button color="blue" onClick={onHandleDateChange}>
              Выбрать дату
            </Button>
          )}
        </Block>
        <Block>
          <Label> По типу курса</Label>
          {optionsCourseType.map((courseType) => (
            <Form>
              <Radio
                value={courseType.value}
                style={{ margin: '5px' }}
                label={courseType.label}
                id={courseType.id}
                checked={selectedCourseType === courseType.value}
                onChange={(e) => onClickCourseType(e.target.value)}
              />
            </Form>
          ))}
        </Block>
        <Block>
          <Label> По статусу оплаты</Label>
          {optionsPaymentStatus.map((paymentStatus) => (
            <Radio
              value={paymentStatus.value}
              style={{ margin: '5px' }}
              label={paymentStatus.label}
              id={paymentStatus.id}
              checked={selectedPaymentStatus === paymentStatus.value}
              onChange={(e) => onClickPaymentStatus(e.target.value)}
            />
          ))}
        </Block>
        <Block>
          <Label>По наличию активного курса</Label>
          {optionsIsCourseActive.map((isCourseActive) => (
            <Radio
              value={isCourseActive.value}
              style={{ margin: '5px' }}
              label={isCourseActive.label}
              id={isCourseActive.id}
              checked={selectedIsCourseActive === isCourseActive.value}
              onChange={(e) => onClickIsCourseActive(e.target.value)}
            />
          ))}
        </Block>
      </TagsGroup>

      <TableBlock>
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>
                <DishTitleLabel>
                  id <br />
                </DishTitleLabel>
              </Table.HeaderCell>
              <Table.HeaderCell>Имя клиента</Table.HeaderCell>
              <Table.HeaderCell>Активный курс/параметры</Table.HeaderCell>
              <Table.HeaderCell>Подписка/ручной</Table.HeaderCell>
              <Table.HeaderCell>Статус оплаты</Table.HeaderCell>
              <Table.HeaderCell>Дата создания</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          {usersList && usersList.data && (
            <Table.Body>
              {usersList.data.map((user) => {
                return (
                  <Table.Row>
                    <React.Fragment>
                      <Table.Cell>
                        <NameBlock> {user.id} </NameBlock>
                      </Table.Cell>
                      <Table.Cell style={{ borderLeft: '0.5px solid #e8e9e9' }}>
                        <NameBlock> {user.name} </NameBlock>
                      </Table.Cell>
                      <Table.Cell style={{ borderLeft: '0.5px solid #e8e9e9' }}>
                        <NameBlock>
                          <ButtonBlock>
                            {user.active_course && (
                              <CourseButton
                              // onClick={() => showVideo(train.video_file.url)}
                              // setIsVideoModalOpen={true}
                              >
                                Активный курс
                              </CourseButton>
                            )}
                            <UserButton
                              target="_blank"
                              to={`/youslim2.0/userPage/${user.id}/change`}
                            >
                              Страница клиента
                            </UserButton>
                          </ButtonBlock>
                        </NameBlock>
                      </Table.Cell>
                      <Table.Cell>
                        <NameBlock>
                          {user.subscription_type
                            ? (user.subscription_type === 1 && 'Ручной') ||
                              (user.subscription_type === 2 && 'Подписка')
                            : '-'}
                        </NameBlock>
                      </Table.Cell>
                      <Table.Cell>
                        <NameBlock> {user.is_paid ? 'Оплачено' : 'Не оплачено'}</NameBlock>
                      </Table.Cell>
                      <Table.Cell>
                        <NameBlock>{user.date_created_user} </NameBlock>
                      </Table.Cell>
                    </React.Fragment>
                  </Table.Row>
                );
              })}
            </Table.Body>
          )}
        </Table>
      </TableBlock>
      {usersList.data && !usersList.data.length && (
        <CentredBlock>Пользователей не найдено</CentredBlock>
      )}
      <ReactPaginate
        previousLabel="<"
        nextLabel=">"
        breakLabel="..."
        pageCount={usersList && usersList.meta && usersList.meta.last_page} // cont
        marginPagesDisplayed={3}
        pageRangeDisplayed={3}
        onPageChange={handlePageClick}
        previousLinkClassName="prev-page-btn"
        nextLinkClassName="next-page-btn"
        containerClassName="pagination"
        activeLinkClassName="active-page-btn"
        pageLinkClassName="page-btn"
        breakClassName="break-me"
        background="white"
      />
      <FooterBlock />
      <ChangeComplexStartDateModal
        isShow={isChangeComplexStartDate}
        onClose={setIsChangeComplexStartDate}
        changeComplexStartDate={onChangeComplexStartDate}
        complexDates={complexDates}
        setComplexDates={setComplexDates}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { usersList, isUsersListLoading } = state.newYouslim;
  return {
    usersList,
    isUsersListLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUsersList: (
      page,
      name,
      type_payment,
      active_course,
      course_is_paid,
      user_create_from_date,
      user_create_to_date,
    ) => {
      dispatch(
        action.getUsersList(
          page,
          name,
          type_payment,
          active_course,
          course_is_paid,
          user_create_from_date,
          user_create_to_date,
        ),
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientList);



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/ClientList/index.jsx